
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/[...productPath]",
      function () {
        return require("private-next-pages/landing/[...productPath].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/[...productPath]"])
      });
    }
  